import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import { WageringCategory } from '../models'

import getAllCategoriesExtraReducer from '../thunks/get-all-categories.thunk'
import getAllGamesExtraReducer from '../thunks/get-all-games.thunk'
import getWCCategoriesExtraReducer from '../thunks/get-wc-categories.thunk'

import saveWCCategoryExtraReducer from '../thunks/save-wc-category.thunk'
import initialState from './initial-state'

const wageringContributionSlice = createSlice({
  name: 'wagering',
  initialState,
  reducers: {
    setWCCategoryAction(state, action: PayloadAction<WageringCategory[]>) {
      state.wageringCategory = action.payload
    },
    setCurrentWageringCategoryAction(
      state,
      action: PayloadAction<WageringCategory>,
    ) {
      state.currentWageringCategory = action.payload
    },
    wageringContributionFailure(state, action: PayloadAction<Error | any>) {
      state.isLoading = false
      state.hasError = true
      state.error = action.payload
    },
    resetGamesList(state) {
      state.gamesList = initialState.gamesList
    },
  },
  extraReducers: (builder) => {
    getAllCategoriesExtraReducer(builder)
    getAllGamesExtraReducer(builder)
    getWCCategoriesExtraReducer(builder)
    saveWCCategoryExtraReducer(builder)
  },
})

export const {
  setWCCategoryAction,
  wageringContributionFailure,
  setCurrentWageringCategoryAction,
  resetGamesList,
} = wageringContributionSlice.actions

export const wageringSelector = ({ wagering }: ApplicationState) => wagering

export default wageringContributionSlice
